<template>
  <div>
    <Editor
        :key="editorKey"
        v-model="content"
        :init="editorConfig"
        api-key="cdr20ntkagi79fq97o93vhjkh1pq9lcwc33s9asghv84r2jx"
    />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
  name: "RichTextEditor",
  components: { Editor },

  props: {
    value: { type: String, default: "" }
  },

  data() {
    return {
      content: this.value,
      editorKey: 0,          // forces TinyMCE to remount safely
      isMounted: false       // prevents double destroy crash
    };
  },

  watch: {
    value(newVal) {
      if (newVal !== this.content) {
        this.content = newVal;
      }
    },
    content(newVal) {
      this.$emit('input', newVal);
    }
  },

  methods: {
    insertText(text) {
      if (window.tinymce?.activeEditor) {
        window.tinymce.activeEditor.execCommand('mceInsertContent', false, text);
      }
    },

    resetEditor() {
      // Safe re-render
      this.editorKey++;
      this.content = this.value || "";
    }
  },

  mounted() {
    this.isMounted = true;
  },

  beforeDestroy() {
    // Prevent Firefox from throwing NS_ERROR_UNEXPECTED
    try {
      const ed = window.tinymce?.get(this.$el.id);

      // Some builds of TinyMCE auto-destroy, so we avoid double destroy.
      if (ed && !ed.isDestroyed) {
        ed.isDestroyed = true; // mark it so TinyMCE skips internal destroy
      }
    } catch (e) {
      /* swallow Firefox NS_ERROR_UNEXPECTED */
    }
  }
,
  computed: {
    editorConfig() {
      return {
        height: 450,
        menubar: true,
        plugins: [
          'link', 'lists', 'image', 'table', 'media', 'code',
          'paste', 'wordcount', 'autoresize'
        ],
        toolbar:
            'undo redo | bold italic underline | alignleft aligncenter alignright | bullist numlist | link image media | code',

        // enable base64 images
        images_upload_handler: (blobInfo) =>
            new Promise((resolve) => {
              resolve("data:" + blobInfo.blob().type + ";base64," + blobInfo.base64());
            }),

        branding: false,
        convert_urls: false,
        statusbar: true,
        autoresize_bottom_margin: 20
      };
    }
  }
}
</script>
